import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";
import styled from "styled-components";
import { Message as MessageProps } from "../../types";

const MessageContainer = styled.div<{isMine: boolean}>`
    display: flex;
    align-self: ${props => props.isMine ? 'flex-end' : 'flex-start'};
    flex-direction: column;
    gap: 4px;
    background-color: ${props => props.isMine ? 'rgb(221, 239, 253)' : 'rgb(245, 245, 245)'};
    padding: 12px;
    border-radius: ${props => props.isMine ? '8px 8px 0px 8px' : '8px 8px 8px 0px'};
    max-width: 292px;  
`

export const Message = ({id, text, dateTime: time, isMine, links: rawLinks} : MessageProps) => {
    const navigate = useNavigate();

    const [links, setLinks] = useState<{text: string, address: string}[]>([])

    useEffect(() => {
        if (rawLinks) {
            setLinks(rawLinks)
        }
    },[rawLinks]);

    return (
        <MessageContainer isMine={isMine} key={id}>
            <p style={{fontSize: '14px'}}>{text}</p>
            <span className="caption-small">{time}</span>
            {links.map(link => (
                <Button onClick={() => navigate(link.address)} key={id+link.address}> 
                    {link.text} 
                </Button>
            ))}
        </MessageContainer>
    )
}